export const SEMINAR_POSITIONS = [
  'Judge',
  'Athlete',
  'Judge Trainee',
  'Instructor',
  'Examiner',
  'Sports Official',
  'Companion',
  'Coach'
]
